import { useOktaAuth } from "@okta/okta-react";
import { fetchData } from "../api-request/nl-api-request";
import { ApplicationState, useApplicationState } from "./application-state";
import { InputParamState } from "./Input-param-state";

const applicationId = process.env.REACT_APP_NL_APPLICATION_UUID ?? '';

export const useMode = () => useApplicationState((state: ApplicationState) => state.application_mode)
export const useSetMode = () => useApplicationState((state: ApplicationState) => state.setMode)
export const useOnlineNetworks = () => useApplicationState((state: ApplicationState) => state.onlineNetworks)
export const useSelectedOnlineNetworks = () => useApplicationState((state: ApplicationState) => state.selectedOnlineNetwork)
export const useClearDetails = () => useApplicationState((state: ApplicationState) => state.clearDetails)
export const useSetSelectedMarker = () => useApplicationState((state: ApplicationState) => state.setSelectedMarker)
export const useSelectedMarker = () => useApplicationState((state: ApplicationState) => state.selectedMarker)
export const useSetNetworkLoaded = () => useApplicationState((state: ApplicationState) => state.setNetworkLoaded)

/* Get networks */
export const getOnlineNetworks= async (paramState: InputParamState, applicationState: ApplicationState, accesToken: string = '') => {
    paramState.setData({ status: "loading" });
    const networkData = await fetchData(`/api/v1/consumer/networks?application_id=${applicationId}`, accesToken);
    if (networkData.status === "successful" && networkData.error === "") {
        applicationState.setOnlineNetworks(networkData.response.items);
    }
    paramState.setData(networkData);
    return networkData;
}

/* Get networks */
export const getNetworkFeatures= async (paramState: InputParamState, applicationState: ApplicationState, accesToken: string = '', params: any, name: string) => {
    paramState.setData({ status: "loading" });
    const networkData = await fetchData(`/api/v1/consumer/networks/${params.id}/features?min_lon=${params.min_lon}&min_lat=${params.min_lat}&max_lon=${params.max_lon}&max_lat=${params.max_lat}`, accesToken);
    if (networkData.status === "successful" && networkData.error === "") {
       applicationState.setSelectedOnlineNetwork(networkData.response)
       applicationState.setNetworkLoaded(name, true)
    }
    paramState.setData(networkData);
    return networkData;
}

export const getFeatureMetadata = async (paramState: InputParamState, applicationState: ApplicationState,feature_id: string, network_id: string, accessToken: string) => {
    paramState.setData({ status: "loading" });
    const metadata = await fetchData(`/api/v1/consumer/networks/${network_id}/features/${feature_id}/metadata`, accessToken);
    if (metadata.status === "successful" && metadata.error === "") {
        paramState.setData(metadata);
        return metadata.response
    }
    paramState.setData(metadata);
    return false
}

export function useAccessToken() {
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken || '';
  return accessToken;
}